import './index.css'

const TabItem = props => {
  const {tabDetails, isActive, onChangeTab} = props
  const {tabId, displayText} = tabDetails

  const onClickTab = () => {
    onChangeTab(tabId)
  }

  const tabBtnClassName = isActive ? 'tab-btn active' : 'tab-btn'

  return (
    <li className="tab-item">
      <button type="button" className={tabBtnClassName} onClick={onClickTab}>
        {displayText}
      </button>
    </li>
  )
}

export default TabItem
